import styles from './styles.module.scss'

export const SpinnerLoading = () => {

  return (
    <div className={styles['spinner-loading']} />
  )
}